import type { VirtualItem } from "@tanstack/react-virtual";
import { type ReactNode, Suspense } from "react";

import { ListChannelItem, ListEpgItem } from "@/components";
import * as styles from "@/features/recommendations/recommendations.css";
import type {
  ChannelResultItem,
  ContinueWatchingItem,
  ProgramResultItem,
} from "@sunrise/backend-types";

export type VirtualListRowItemProps = {
  virtualItem: VirtualItem;
  item: ChannelResultItem | ProgramResultItem | ContinueWatchingItem;
  "data-testid": string;
  index: number;
  isFocused: boolean;
  kind: "normal" | "large" | "channel";
};

export function VirtualListRowItem({
  virtualItem,
  item,
  "data-testid": dataTestId,
  isFocused,
  index,
  kind,
}: VirtualListRowItemProps): ReactNode {
  return (
    <div
      className={styles.virtualItem}
      style={{
        width: `${virtualItem.size}px`,
        transform: `translateX(${virtualItem.start}px)`,
      }}
    >
      {item.type === "channel" ? (
        <Suspense>
          <ListChannelItem
            data-testid={`${dataTestId}.${index}.item.${virtualItem.index}`}
            item={item}
            focused={isFocused}
            // TODO: provide value from backend, even if null
            posterUrl={null}
          />
        </Suspense>
      ) : (
        <Suspense>
          <ListEpgItem
            data-testid={`${dataTestId}.${index}.item.${virtualItem.index}`}
            item={item}
            kind={kind}
            focused={isFocused}
          />
        </Suspense>
      )}
    </div>
  );
}
